import './index.scss'
import {
  Tooltip,
  TooltipDefinition,
  TooltipIcon
} from 'carbon-components-react'

Tooltip.Icon = TooltipIcon
Tooltip.Definition = TooltipDefinition

export { Tooltip, TooltipIcon, TooltipDefinition, Tooltip as default }
